import React, { useEffect, useState } from 'react'
import MyListBlock from '../../../../UI/list/MyListBlock'
import { getUserName } from '../../../../../helpers/user/UserHelper'
import { departmentText } from '../../../../../helpers/department/DepartmentHelper'
import EditUserInSupplyOrderButton from '../../forms/editUserInSupplyOrder/EditUserInSupplyOrderButton'
import { useSelector } from 'react-redux'

const SupplyOrderClient = ({ supplyOrderId }) => {

    const supplyOrder = useSelector(state => state.supplyOrder.supplyOrder)

    const [list, setList] = useState([])

    useEffect(() => {
        setListItems()
    }, [supplyOrder.client, supplyOrder.user])

    const setListItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'Замовник',
            value: supplyOrder.client ? getUserName({ user: supplyOrder.client }) : '-'
        })
        listTemp.push({
            name: 'Підрозділ',
            // value: supplyOrder.department ? departmentText[supplyOrder.department.type] + ' - ' + supplyOrder.department.department.name : '-'
            value: 
                supplyOrder.departmentType ? supplyOrder.departmentType.name + ' - ' + supplyOrder.department.name : '-'
        })
        listTemp.push({
            name: 'Відповідальний',
            value: 
                supplyOrder.user ? 
                    <div>
                        {getUserName({ user: supplyOrder.user })}
                        <EditUserInSupplyOrderButton 
                            supplyOrderId={supplyOrderId} 
                            user={supplyOrder.user} 
                        />
                    </div>
                :
                    <EditUserInSupplyOrderButton 
                        supplyOrderId={supplyOrderId} 
                    />
        })

        setList(listTemp)
    }

  return (
    <MyListBlock
        className={'supplyOrderView__topBlock'}
        text={'Замовник'}
        list={list}
    />
    // <div className='supplyOrderView__client'>
    //     client
    // </div>
  )
}

export default SupplyOrderClient